
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue"
import DuttiesContent from "./components/DutiesContent.vue";


export default defineComponent({
  name: "DutiesPage",
  components: {
    BreadCrumb,
    DuttiesContent
},
});
